import { CircularProgress } from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import React from "react";

const Loader = () => {
  return (
    <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={true}>
      <CircularProgress sx={{ color: "#75B83E" }} />
    </Backdrop>
  );
};

export default Loader;
